import type { ShepherdOptionsWithType } from "react-shepherd";

const startButtons = [
  {
    classes: "shepherd-button-primary",
    text: "Start",
    type: "next",
  },
];

const nextButtonOnly = [
  {
    classes: "shepherd-button-primary",
    text: "Next",
    type: "next",
  },
];
const endButtons = [
  {
    classes: "shepherd-button-primary",
    text: "Finish",
    type: "complete",
  },
];

export const tourSteps: ShepherdOptionsWithType[] = [
  {
    id: "step0",
    title: "SKU Management Interactive Tour",
    text: [
      "Welcome to a live tour! Let's go through a few steps to help you get started with managing the Stock Keeping Units (SKUs) for your territory. <b>Please remember this tour is live! Which means any actions you carry out are real and will affect the system.</b></br></br><b>Click Start to begin.</b>",
    ],
    buttons: startButtons,
  },

  {
    id: "step1",
    attachTo: {
      element: '[data-tourid="sku-management-description"]',
      on: "bottom",
    },
    title: "What are Stock Keeping Units?",
    text: [
      "There is an explanation of what SKUs are and how they link to the territory clinical product list. In short, you must have a clinical product before you can create SKUs.",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step2",
    attachTo: {
      element: '[data-tourid="skuManagement-clinical-product-search"]',
      on: "bottom",
    },
    title: "Searching Clinical Products",
    text: [
      "You can see which clinical products are available in your territory by searching here. </br></br><b>If you cannot find something you are looking for, please contact a Product Manager</b>",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step3",
    attachTo: { element: '[data-testid="row-0"]', on: "bottom" },
    title: "Clinical Products list",
    text: [
      "These are all the clinical products that have matched the search term. Let's click on one.</br></br><b>Click the highlighted area to continue</b>",
    ],
    advanceOn: { selector: '[data-testid="row-0"]', event: "click" },
  },
  {
    id: "step4",
    title: "SKUs",
    text: [
      "We have selected a clinical product and now we can see all the SKUs linked to it.",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step5",
    attachTo: {
      element: '[data-tourid="sku-table-disable-button"]',
      on: "bottom",
    },
    title: "Active and Inactive SKUs",
    text: [
      "SKUs can be active or inactive and you can update their status here.</br></br>Inactive SKUs will be hidden in the rest of the application for the whole territory. You will get a warning modal pop up to remind you when you try to deactivated an SKU.",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step6",
    attachTo: { element: '[data-tourid="sku-add-button"]', on: "bottom" },
    title: "Adding a new SKU",
    text: [
      "To add a new SKU to this clinical product you can press this button here. Let's click the button to take a look.</br></br><b>Click the highlighted area to continue</b>",
    ],
    advanceOn: { selector: '[data-tourid="sku-add-button"]', event: "click" },
  },
  {
    id: "step7",
    title: "A new SKU",
    text: [
      "The name is the most important field as it is what our user will see when they dispense or receive.</br></br>It will automatically populate with the name of the Clinical Product you are creating it on to help you construct a useful SKU name.",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step8",
    attachTo: { element: '[data-tourid="add-sku-form"]', on: "bottom" },
    title: "Quantity and Unit",
    text: [
      "The whole purpose of an SKU is to define an amount of a clinical product and in what form, so these three fields are the only information you can populate.</br></br><b>Change these values and click Next</b>",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step9",
    attachTo: {
      element: '[data-tourid="add-sku-form-name-field"]',
      on: "bottom",
    },
    title: "Auto updated name",
    text: [
      "If you update the values, you may see that quantity and unit has been appended to the name. This only happens on 'g', 'litre', 'mg', 'ml', and 'vial' units and is to help you structure the names correctly but you can also edit this field to anything you need.</br></br><b>Please note: If you edit this name field, then change the quantity or unit, it can overwrite your name changes, so it is best to select the quantity and unit first.</b>",
    ],
    buttons: nextButtonOnly,
  },
  {
    id: "step10",
    title: "You're all set!",
    text: [
      "Thank you for taking the tour. If you require any further help or information about SKU Management, please contact the Product team.",
    ],
    buttons: endButtons,
  },
];
